module.exports = __WEBPACK_EXTERNAL_MODULE_2__;


//////////////////
// WEBPACK FOOTER
// external {"amd":"react","commonjs":"react","commonjs2":"react","root":"React"}
// module id = 2
// module chunks = 0